// extracted by mini-css-extract-plugin
module.exports = {"sideCards":"RoundModules_sideCards__1lyJZ","swiper":"RoundModules_swiper__5yxPE","carousel":"RoundModules_carousel__1Ku9s","breakOut":"RoundModules_breakOut__2jOml"};